var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "asc__insertPage" },
    [
      _c("SalesMaximumExcelModal", { on: { success: _vm.successExcelImport } }),
      _vm._v(" "),
      _c("b-col", { attrs: { cols: "12" } }, [
        _c(
          "header",
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "8" } },
                  [_c("Breadcrumb")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "text-right", attrs: { cols: "12", md: "4" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "SalesMaximumQuantity" } } },
                      [_c("CancelButton")],
                      1
                    ),
                    _vm._v(" "),
                    _c("AddButton", {
                      nativeOn: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "asc__insertPage-content-head", attrs: { cols: "12" } },
        [
          _c(
            "section",
            [
              _c(
                "b-row",
                [
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        title: _vm.$t("insert.SalesMaximumQuantity.Code"),
                        error: _vm.$v.form.Code
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: { type: "text", disabled: true },
                        model: {
                          value: _vm.form.Code,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Code", $$v)
                          },
                          expression: "form.Code"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        title: _vm.$t(
                          "insert.SalesMaximumQuantity.Description1"
                        ),
                        error: _vm.$v.form.Description1
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          disabled: _vm.insertReadonly.Description1
                        },
                        model: {
                          value: _vm.form.Description1,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Description1", $$v)
                          },
                          expression: "form.Description1"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        title: _vm.$t("insert.SalesMaximumQuantity.StatusId"),
                        error: _vm.$v.form.StatusId
                      }
                    },
                    [
                      _c("NextCheckBox2", {
                        attrs: {
                          type: "number",
                          disabled: _vm.insertReadonly.StatusId,
                          toggle: ""
                        },
                        model: {
                          value: _vm.form.StatusId,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "StatusId", $$v)
                          },
                          expression: "form.StatusId"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        title: _vm.$t("insert.SalesMaximumQuantity.BeginDate"),
                        error: _vm.$v.form.BeginDate
                      }
                    },
                    [
                      _c("NextDatePicker", {
                        attrs: { disabled: _vm.insertReadonly.BeginDate },
                        model: {
                          value: _vm.form.BeginDate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "BeginDate", $$v)
                          },
                          expression: "form.BeginDate"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        title: _vm.$t("insert.SalesMaximumQuantity.EndDate"),
                        error: _vm.$v.form.EndDate
                      }
                    },
                    [
                      _c("NextDatePicker", {
                        attrs: { disabled: _vm.insertReadonly.EndDate },
                        model: {
                          value: _vm.form.EndDate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "EndDate", $$v)
                          },
                          expression: "form.EndDate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-tabs",
            [
              _c(
                "b-tab",
                {
                  attrs: {
                    title: _vm.$t("insert.SalesMaximumQuantity.CustomerList")
                  }
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("insert.SalesMaximumQuantity.Code"),
                            error: _vm.$v.salesMaximum.Code
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { disabled: false, type: "text" },
                            model: {
                              value: _vm.salesMaximum.Code,
                              callback: function($$v) {
                                _vm.$set(_vm.salesMaximum, "Code", $$v)
                              },
                              expression: "salesMaximum.Code"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("insert.SalesMaxQuantity.CustomerId"),
                            error: _vm.$v.salesMaximum.CustomerId,
                            required: true
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              url:
                                "VisionNextCustomer/api/Customer/AutoCompleteSearch",
                              dynamicAndCondition: { StatusId: [1] },
                              "custom-option": true,
                              "is-customer": true,
                              label: "Description1"
                            },
                            model: {
                              value: _vm.salesMaximum.CustomerId,
                              callback: function($$v) {
                                _vm.$set(_vm.salesMaximum, "CustomerId", $$v)
                              },
                              expression: "salesMaximum.CustomerId"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("insert.SalesMaxQuantity.Quantity"),
                            error: _vm.$v.salesMaximum.Quantity
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "text" },
                            on: {
                              keypress: function($event) {
                                return _vm.onlyForCurrencyDotOrComma($event)
                              }
                            },
                            model: {
                              value: _vm.salesMaximum.Quantity,
                              callback: function($$v) {
                                _vm.$set(_vm.salesMaximum, "Quantity", $$v)
                              },
                              expression: "salesMaximum.Quantity"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: "Üst Limitleme Yöntemi",
                            error: _vm.$v.form.StatusId
                          }
                        },
                        [
                          _c("NextCheckBoxSalesMaximumQty", {
                            attrs: {
                              type: "number",
                              disabled: _vm.insertReadonly.StatusId,
                              toggle: ""
                            },
                            model: {
                              value: _vm.salesMaximum.IsTotalQuantity,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.salesMaximum,
                                  "IsTotalQuantity",
                                  $$v
                                )
                              },
                              expression: "salesMaximum.IsTotalQuantity"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "text-right",
                          attrs: { cols: "12", md: "2", lg: "2" }
                        },
                        [
                          _c(
                            "b-form-group",
                            [
                              _c("AddDetailButton", {
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.addSalesMaximumQuantityCustomers(
                                      $event
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "12", md: "2" } },
                        [
                          _c(
                            "b-form-group",
                            [
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "b-modal",
                                      rawName:
                                        "v-b-modal.sales-maximum-excel-modal",
                                      modifiers: {
                                        "sales-maximum-excel-modal": true
                                      }
                                    }
                                  ],
                                  staticClass: "mt-4",
                                  attrs: { size: "sm", variant: "success" }
                                },
                                [
                                  _c("i", { staticClass: "fas fa-file-pdf" }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "insert.creditBudget.uploadExcel"
                                        )
                                      )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-table-simple",
                        { attrs: { bordered: "", small: "" } },
                        [
                          _c(
                            "b-thead",
                            [
                              _c("b-th", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("insert.SalesMaximumQuantity.Code")
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("b-th", [
                                _c("span", [_vm._v(_vm._s("Müşteri Kodu"))])
                              ]),
                              _vm._v(" "),
                              _c("b-th", [
                                _c("span", [_vm._v(_vm._s("Müşteri Adı"))])
                              ]),
                              _vm._v(" "),
                              _c("b-th", [
                                _c("span", [
                                  _vm._v(_vm._s("Üst Limitleme Yöntemi"))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("b-th", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("insert.SalesMaxQuantity.Quantity")
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("b-th", [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("list.operations")))
                                ])
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-tbody",
                            _vm._l(
                              _vm.SalesMaximum
                                ? _vm.SalesMaximum.filter(function(f) {
                                    return f.RecordState !== 4
                                  })
                                : [],
                              function(f, i) {
                                return _c(
                                  "b-tr",
                                  { key: i },
                                  [
                                    _c("b-td", [_vm._v(_vm._s(f.Code))]),
                                    _vm._v(" "),
                                    _c("b-td", [
                                      _vm._v(
                                        _vm._s(
                                          f.Customer
                                            ? f.Customer.Code
                                            : f.CustomerCode
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("b-td", [
                                      _vm._v(
                                        _vm._s(
                                          f.Customer
                                            ? f.Customer.Label
                                            : f.CustomerName
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("b-td", [
                                      _vm._v(_vm._s(f.IsTotalQuantity))
                                    ]),
                                    _vm._v(" "),
                                    _c("b-td", [
                                      _vm._v(
                                        _vm._s(_vm.formatValue(f.Quantity))
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "b-td",
                                      { staticClass: "text-center" },
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            staticClass:
                                              "btn mr-2 btn-warning btn-sm",
                                            on: {
                                              click: function($event) {
                                                return _vm.editSalesMaximum(f)
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-pencil-alt"
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-button",
                                          {
                                            staticClass:
                                              "btn mr-2 btn-danger btn-sm",
                                            on: {
                                              click: function($event) {
                                                return _vm.removeSalesMaximum(f)
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "far fa-trash-alt"
                                            })
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              }
                            ),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35870945", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35870945","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SalesMaximumQuantity/update.vue
// module id = null
// module chunks = 